// import external dependencies
import 'jquery';
import 'slick-carousel'
import 'bootstrap';
import 'bootstrap/dist/js/bootstrap.min';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

$(document).ready(function(){
  $("#myTab a").click(function(e){
      e.preventDefault();
      $(this).tab("show");
  });
});



// WEBPACK FOOTER //
// ./scripts/main.js